import { EntityType } from './reserveMonitoringList'

export type PermissionSourceType = 'UserBased' | 'RoleBased' | 'None'
export type ActionType = 'Create' | 'Read' | 'Update' | 'Delete'
export type EntityTypeForRoleManagement =
  | 'Channel'
  | 'Tenant'
  | 'Accommodation'
  | 'Provider'
  | undefined
// Was missing Tenant and Accommodation -- the same stale-hardcoded-list defect as
// roleBasicInfo.tsx's inline MenuItem list (BL-234), found while fixing that one.
export const EntityTypes: {
  label: string
  value: EntityTypeForRoleManagement
}[] = [
  {
    label: 'Channel',
    value: 'Channel'
  },
  {
    label: 'Provider',
    value: 'Provider'
  },
  {
    label: 'Accommodation',
    value: 'Accommodation'
  },
  {
    label: 'Tenant',
    value: 'Tenant'
  }
]

export type RolesFilters = {
  roleName?: string
  isActive?: boolean
}

export type RoleInput = {
  roleID?: string
  name: string
  description: string
  isActive: boolean
  permissionIDs: string[]
}

export type PermissionAction = {
  permissionID: string
  action: ActionType
  selected: boolean
  disabled: boolean
  permissionSource: PermissionSourceType
}

export type SubPermission = {
  name: string
  actions: PermissionAction[]
}

export type Permission = {
  permissionName: string
  subPermissions: SubPermission[]
}

export type RoleDetails = {
  roleID: string
  name: string
  description: string
  entityType?: EntityType
  isActive: boolean
  permissions: Permission[]
  // Whether the current user may change or delete this role. null/undefined: the backend
  // did not say (an older IAM), so the actions stay available.
  canManage?: boolean | null
}

// What the current user may create and grant, from IAM. The backend refuses anything else.
export type RoleManagementScope = {
  unrestricted: boolean
  creatableEntityTypes: EntityTypeForRoleManagement[]
  grantablePermissionIDs: string[]
}

export type RoleBrief = {
  roleID: string
  displayRoleID: string
  name: string
  description: string
  entityType?: EntityType
  isActive: boolean
  canManage?: boolean | null
}

export type DeleteRoleResponse = {
  message: string
  userAffected: number
}
